var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7939 9.80376C13.7939 9.80376 14.1128 4.0536 18.995 3.93524C23.8805 3.82017 24.1665 9.77417 24.1665 9.77417L20.8427 9.80376C20.8427 9.80376 20.435 5.90128 19.281 5.75662C18.1271 5.61196 17.2032 9.6854 17.2032 9.6854L13.7939 9.80047V9.80376Z",
    fill: "url(#paint0_linear_321_4142)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70605 13.2425C4.57509 18.2233 3.96358 24.9499 3.49015 32.1467C3.34221 34.3823 4.9729 36.3483 7.19866 36.6015C14.1653 37.3938 22.8217 37.0815 32.1062 36.3615C34.5226 36.1741 36.2881 33.9911 35.9527 31.5911C34.9401 24.3647 33.7631 17.7302 32.1653 12.5751C31.6853 11.0299 30.3735 9.89564 28.7724 9.65564C23.2853 8.83043 16.539 9.20851 9.34552 10.0173C7.57017 10.2178 6.10057 11.5033 5.70276 13.2458L5.70605 13.2425Z",
    fill: "url(#paint1_linear_321_4142)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9556 31.5914C35.1962 26.1568 34.3381 21.0576 33.2827 16.6686C33.2334 17.1091 33.1742 17.5497 33.1019 17.9869C32.4279 22.0472 30.6362 26.0714 27.4175 28.6357C23.4263 31.8117 17.8997 32.2818 12.8301 31.6999C10.2065 31.4007 7.58948 30.8549 4.94947 30.9733C4.4892 30.993 4.02563 31.039 3.56536 31.1114C3.54234 31.4566 3.51933 31.8018 3.49632 32.147C3.34837 34.3826 4.97906 36.3487 7.20482 36.6018C14.1714 37.3941 22.8279 37.0818 32.1123 36.3618C34.5288 36.1744 36.2943 33.9914 35.9589 31.5914H35.9556Z",
    fill: "#5C3600"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72631 10.5464C4.21015 12.0686 3.89782 13.8407 3.71371 15.7739C3.32247 19.8802 6.04139 23.6807 10.0589 24.6177C15.6907 25.9295 21.556 25.8276 27.6086 24.5553C32.2377 23.5854 35.1966 18.9728 34.0262 14.3898C33.6382 12.8774 33.1648 11.3914 32.6026 9.93823C32.2442 9.01439 31.3796 8.38644 30.3933 8.29767C22.9401 7.61712 15.0694 7.86041 6.88961 8.7974C5.89015 8.91247 5.04522 9.59302 4.72302 10.5464H4.72631Z",
    fill: "url(#paint2_linear_321_4142)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6121 24.5555C32.2412 23.5856 35.2001 18.973 34.0297 14.39C33.6417 12.8776 33.1683 11.3916 32.6061 9.93845C32.2478 9.01461 31.3831 8.38667 30.3968 8.2979C29.8773 8.25187 29.3546 8.20913 28.8319 8.16968C28.9831 8.53132 29.1245 8.89954 29.2362 9.28749C29.5979 10.5237 29.7393 11.8289 29.6275 13.1144C29.302 16.8393 26.8592 20.3078 23.4598 21.8662C21.1157 22.9412 18.4362 23.1319 15.8784 22.7999C13.3206 22.4678 10.8548 21.636 8.43835 20.7352C7.12985 20.2486 5.69313 19.7522 4.33203 19.7555C5.33149 22.1325 7.4093 23.9966 10.0625 24.6147C15.6943 25.9265 21.5595 25.8245 27.6121 24.5522V24.5555Z",
    fill: "#E58E0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22474 9.53731C7.84665 9.57018 7.45542 9.60964 7.12665 9.79375C6.7946 9.97786 6.53816 10.3494 6.60391 10.7209C6.65323 10.9938 6.85706 11.2107 7.06747 11.3916C8.43186 12.5784 10.319 13.042 12.1239 12.9433C13.9289 12.848 15.6681 12.2398 17.3185 11.4935C17.93 11.2173 18.7453 10.6847 18.4922 9.87923C18.3179 9.32361 17.6111 9.20525 17.1113 9.1658C15.2505 9.01457 13.2976 9.20196 11.4368 9.30388C10.365 9.36306 9.29652 9.43868 8.22803 9.53073L8.22474 9.53731Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9261 29.5627C18.3311 29.5627 17.759 29.5331 17.2133 29.4772C16.3256 29.3852 15.599 28.7441 15.405 27.886C15.0894 26.5084 14.9152 25.532 14.8395 24.7232C14.7343 23.589 15.5595 22.5797 16.6839 22.4712C18.7157 22.2739 20.4253 22.2443 21.9048 22.3824C22.8746 22.4712 23.6571 23.2438 23.7656 24.2169C23.907 25.4893 23.8807 26.6564 23.6867 27.6854C23.5256 28.5534 22.8253 29.2175 21.9475 29.3391C20.8889 29.4871 19.8763 29.5594 18.9261 29.5594V29.5627ZM15.8522 24.6279C15.9245 25.3906 16.0922 26.3276 16.3946 27.6591C16.4933 28.0931 16.8648 28.4153 17.3152 28.4613C18.6533 28.6027 20.1656 28.5567 21.8061 28.3298C22.25 28.2674 22.6018 27.9353 22.684 27.498C22.8582 26.5676 22.8812 25.4991 22.7497 24.3287C22.6938 23.8323 22.2993 23.441 21.8094 23.395C20.3924 23.2635 18.7486 23.2931 16.7793 23.4838C16.2138 23.5397 15.7995 24.0493 15.8522 24.6246V24.6279Z",
    fill: "url(#paint3_linear_321_4142)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8451 20.6133C18.6731 20.3635 20.3761 20.2418 21.7503 20.4588C21.9344 20.4884 22.0758 20.6396 22.1054 20.8238C22.2533 21.7081 22.204 22.8095 22.0824 23.9931C22.0594 24.2101 21.8818 24.3744 21.6648 24.381L17.2363 24.5092C17.0226 24.5158 16.8352 24.3646 16.7958 24.1542C16.5854 22.9805 16.4341 21.8824 16.467 21.0276C16.4736 20.8172 16.6347 20.6429 16.8451 20.6133ZM17.0752 28.4676C17.0391 29.6282 17.1804 30.6802 17.4336 31.6665C17.4599 31.7652 17.4994 31.8572 17.5585 31.9394C17.9859 32.5411 18.6303 33.0802 19.3569 33.5964C19.6232 33.7871 19.9783 33.8002 20.2577 33.626C20.9777 33.1822 21.5859 32.6364 22.0627 31.9723C22.135 31.8704 22.1843 31.752 22.204 31.6271C22.3717 30.598 22.4342 29.4901 22.4144 28.3197C22.4079 27.8956 22.0791 27.5438 21.655 27.5142C20.1821 27.4123 18.8111 27.4221 17.6868 27.6983C17.335 27.7838 17.0917 28.106 17.0818 28.4676H17.0752Z",
    fill: "url(#paint4_linear_321_4142)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8494 30.2793C20.8494 30.8185 20.4154 31.1834 19.8729 31.1834C19.3305 31.1834 18.8932 30.7462 18.8932 30.2037C18.8932 29.6612 19.3798 29.2601 19.9189 29.2601C20.4581 29.2601 20.8461 29.7368 20.8461 30.2793H20.8494Z",
    fill: "url(#paint5_linear_321_4142)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_4142",
    x1: 10.2596,
    y1: -14.0813,
    x2: 21.0597,
    y2: 14.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_4142",
    x1: 15.7006,
    y1: -33.3769,
    x2: 21.5099,
    y2: 61.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_4142",
    x1: 17.8244,
    y1: -14.4334,
    x2: 20.8294,
    y2: 65.9078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_321_4142",
    x1: 19.0379,
    y1: 18.4076,
    x2: 20.7738,
    y2: 56.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_4142",
    x1: 18.4955,
    y1: -14.772,
    x2: 19.6199,
    y2: 32.6496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_321_4142",
    x1: 19.8565,
    y1: 29.6021,
    x2: 20.3135,
    y2: 49.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E58E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceMenuIcon);
export default __webpack_public_path__ + "static/media/marketplace-menu-icon.c793e83d3ebe6f02421d8e191ae9b38f.svg";
export { ForwardRef as ReactComponent };